module.exports = __webpack_public_path__ + "img/Canvas-top.a1cc26ea.png";